/**
 * defa.views.AlarmGroupFlow
 * A flow for getting alarm groups.
 * @version 1.2.0
 */
import AlarmGroups          from 'scripts/defa/alarm-groups/collection-alarm-groups';
import AlarmGroupErrorForm  from 'scripts/defa/alarm-groups/view-alarm-group-error-form';
import AlarmGroupOptionForm from 'scripts/defa/alarm-groups/view-alarm-group-option-form';
import Flow                 from 'scripts/poppet/flow';
import template             from 'templates/alarmGroupFlow.jst.html';

const selectors = {
	container: '[data-region=alarm-group-container]',
};

const AlarmGroupFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.container,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to change AlarmGroups.
	 * @void
	 */
	onChildviewChange: function () {
		this.alarmGroupOption = true;
		this.dispatch();
	},
	
	/**
	 * Triggers when a childView requests to clear AlarmGroups.
	 * @void
	 */
	onChildviewClear: function () {
		this.trigger( 'alarmGroup:clear' );
	},
	
	/**
	 * Triggers when a childView requests to skip AlarmGroup options.
	 * @void
	 */
	onChildviewSkip: function () {
		this.trigger( 'alarmGroup:skip' );
	},
	
	/**
	 * Triggers when a childView requests to test the unit anew.
	 * @void
	 */
	onChildviewRetest: function () {
		this.trigger( 'retest' );  // unit:test
	},
	
	/**
	 * Triggers when a new collection of alarmGroups are fetched.
	 * @param {collection}  A new collection of alarmGroups
	 * @void
	 */
	onSyncAlarmGroups: function ( alarmGroups ) {
		
		// if empty results, or failed test, show error
		if ( 0 === alarmGroups.length || !this.options.unit.get( 'transientSecurity' ) ) {
			this._showAlarmGroupError();
			
			// if got results, return results
		} else {
			this.trigger( 'alarmGroup:change', alarmGroups );
		}
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Dispatch flow for alarmGroup options.
	 * @void
	 */
	dispatch: function () {
		
		let fn   = false,
			self = this;
		
		if ( !self.alarmGroupOption ) {
			fn = self._showAlarmGroupOption;
		}
		
		if ( self.alarmGroupOption ) {
			fn = self._getAlarmGroups();
		}
		
		if ( _.isFunction( fn ) ) {
			fn.call( self );
		}
	},
	
	/**
	 * Shows options to decide how to handle AlarmGroups.
	 * @void
	 */
	_showAlarmGroupOption: function () {
		
		let alarmGroupOptionForm = new AlarmGroupOptionForm( {
			model: this.options.unit,
		} );
		this.showChildView( 'container', alarmGroupOptionForm );
	},
	
	/**
	 * Shows an AlarmGroupError if AlarmGroups aren't available.
	 * @void
	 */
	_showAlarmGroupError: function () {
		
		let alarmGroupErrorForm = new AlarmGroupErrorForm();
		this.showChildView( 'container', alarmGroupErrorForm );
	},
	
	/**
	 * Fetches a collection of alarmGroups.
	 * @void
	 */
	_getAlarmGroups: function () {
		let alarmGroups = new AlarmGroups();
		
		this.listenToOnce( alarmGroups, 'sync', this.onSyncAlarmGroups );
		
		alarmGroups.fetch( {
			data       : {
				customerId          : this.options.customer.get( 'id' ),
				settingsAutomotiveId: this.options.settingsAutomotive.get( 'id' ),
			},
			processData: true,
		} );
	},
	
} );

export default AlarmGroupFlow;